export default "__VITE_ASSET__BKgNvxPn__"